import { useState, useMemo } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import * as apiClient from "../api-client";

const MyBlogs = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { data: blogData } = useQuery("fetchMyBlogs", apiClient.fetchMyBlogs, {
    onError: () => {},
  });

  const [searchQuery, setSearchQuery] = useState("");

  const deleteMutation = useMutation(apiClient.deleteBlog, {
    onSuccess: () => {
      queryClient.invalidateQueries("fetchMyBlogs");
    },
  });

  const filteredBlogs = useMemo(() => {
    return blogData
      ? blogData.filter((blog) =>
          blog.title.toLowerCase().includes(searchQuery.toLowerCase())
        )
      : [];
  }, [blogData, searchQuery]);

  const handleEdit = (slug: string) => {
    navigate(`/edit-blog/${slug}`);
  };

  if (!blogData) {
    return <span>No Blogs found</span>;
  }

  return (
    <div className="mt-10 px-4 md:px-0">
  <div className="flex flex-col md:flex-row items-start md:items-center md:justify-between mb-4">
    <input
      type="text"
      placeholder="Search by blog title"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="border border-gray-300 rounded-md p-2 mb-2 md:mb-0 md:mr-2 flex-grow md:flex-grow-0 md:w-10/12 w-full"
    />
    <Link
      to="/add-blog"
      className="md:w-2/12 h-[40px] md:ml-4 mx-auto bg-halo-pink px-6 py-2.5 text-sm font-bold uppercase tracking-wide text-white transition-none hover:bg-pink-800 sm:mt-0 sm:w-auto sm:shrink-0 text-center rounded-md"
    >
      Add Blog
    </Link>
  </div>
  <div className="overflow-x-auto">
    <table className="min-w-full bg-white border-collapse">
      <thead>
        <tr>
          <th className="py-3 px-4 border-b-2 text-center">Title</th>
          <th className="py-3 px-4 border-b-2 text-center">Content</th>
          <th className="py-3 px-4 border-b-2 text-center">Quote</th>
          <th className="py-3 px-4 border-b-2 text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredBlogs.slice().reverse().map((blog) => (
          <tr key={blog._id} className="hover:bg-gray-100 transition-colors duration-200">
            <td className="py-3 px-4 border-b text-center">{blog.title}</td>
            <td className="py-3 px-4 border-b text-center">
              {blog.content.length > 100 ? `${blog.content.slice(0, 100)}...` : blog.content}
            </td>
            <td className="py-3 px-4 border-b text-center">{blog.quote.join(", ")}</td>
            <td className="py-3 px-4 border-b text-center">
              <div className="flex justify-center space-x-2">
                <Link
                  to={`/blogs/${blog.slug}`}
                  className="px-4 py-2.5 border text-green-600 text-sm rounded uppercase border-green-600 hover:bg-green-600 hover:text-white transition-colors duration-200"
                >
                  View
                </Link>
                <button
                  onClick={() => handleEdit(blog.slug)}
                  className="px-4 py-2.5 border text-blue-600 text-sm rounded uppercase border-blue-600 hover:bg-blue-600 hover:text-white transition-colors duration-200"
                >
                  Edit
                </button>
                <button
                  onClick={async () => {
                    const confirmed = window.confirm("Are you sure you want to delete this blog?");
                    if (confirmed) {
                      try {
                        await deleteMutation.mutateAsync(blog.slug);
                      } catch (error) {
                        console.error("Failed to delete blog:", error);
                      }
                    }
                  }}
                  className="px-4 py-2.5 border text-red-600 text-sm rounded uppercase border-red-600 hover:bg-red-600 hover:text-white transition-colors duration-200"
                >
                  Delete
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

  );
};

export default MyBlogs;
